const QIMap = require('./src/js/map').default;
module.exports = QIMap;
